import type { Translate } from '@elec/i18n';
import { Dialog } from './ui.tsx';

/** First run: what the app does, how to start, in five steps, and the guided tutorial. Shown once. */
export function WelcomeDialog(props: {
  t: Translate;
  onClose(): void;
  onTemplate(): void;
  onDemo(): void;
  onTour(): void;
}) {
  const { t } = props;
  return (
    <Dialog
      title={t('welcome.title')}
      wide
      onClose={props.onClose}
      actions={
        <>
          <button onClick={props.onClose} data-testid="welcome-empty">
            {t('welcome.empty')}
          </button>
          <button onClick={props.onDemo} data-testid="welcome-demo">
            {t('welcome.demo')}
          </button>
          <button onClick={props.onTemplate} data-testid="welcome-template">
            {t('welcome.template')}
          </button>
          <button className="primary" onClick={props.onTour} data-testid="welcome-tour">
            {t('tour.welcome')}
          </button>
        </>
      }
    >
      <p>{t('welcome.intro')}</p>
      <ol className="welcome-steps">
        {([1, 2, 3, 4, 5] as const).map((i) => (
          <li key={i}>
            <strong>{t(`welcome.s${i}.title`)}</strong> — {t(`welcome.s${i}.body`)}
          </li>
        ))}
      </ol>
      <p className="notice">{t('about.beta')}</p>
    </Dialog>
  );
}
